<template>
  <div class="worksCenterdatails-section" v-loading="loading">
    <div class="datails-mark">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>课件中心</el-breadcrumb-item>
        <el-breadcrumb-item>课件详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="datails-title">{{ coursewareInfo.name }}</div>
    <div class="datail-information">
      <span
        >阅读量：
        <span class="information-value">{{ coursewareInfo.hits_number }}</span>
      </span>
      <el-divider direction="vertical"></el-divider>
      <span
        >订阅量：
        <span class="information-value">{{
          coursewareInfo.subscribe_number
        }}</span>
      </span>
      <el-divider direction="vertical"></el-divider>
      <span
        >下载量：
        <span class="information-value">{{
          coursewareInfo.download_number
        }}</span>
      </span>
    </div>
    <div class="temporary_show-container" v-if="!coursewareInfo.name">
      暂无数据
    </div>
    <div class="datail-img">
      <img :src="(coursewareInfo.image || {}).file_src" />
    </div>
    <div class="worksCenterdatails-content">
      <div
        class="worksCenterdatails-main"
        v-html="coursewareInfo.content"
      ></div>
    </div>
    <div class="datail-button-content">
      <div class="left-button">
        <el-button
          type="primary"
          size="small"
          @click="() => this.$router.back()"
          >返回课件中心</el-button
        >
      </div>
      <div class="hanle-button">
        <el-button plain icon="el-icon-download" size="small" @click="downLoad"
          >下载课件包</el-button
        >
        <el-button
          type="primary"
          size="small"
          :plain="coursewareInfo.is_subscribed"
          @click="subscribe"
          >{{
            coursewareInfo.is_subscribed === true ? "已订阅" : "订阅"
          }}</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import classService from "@/global/service/class";
export default {
  data() {
    return {
      coursewareInfo: {},
      loading: false
    };
  },
  created() {
    this.getData();
  },
  methods: {
    downLoad() {
      let id = this.coursewareInfo.id;
      classService.coursewareDownload(id).then(() => {
        const el = document.createElement("a");
        document.body.appendChild(el);
        el.href = this.coursewareInfo.file.file_src;
        el.download = this.coursewareInfo.file.file_name;
        el.target = "_blank";
        el.click();
        document.body.removeChild(el);
      });
    },
    subscribe() {
      if (this.coursewareInfo.is_subscribed) {
        this.$message.warning("您已订阅");
        return;
      }
      let id = this.coursewareInfo.id;
      classService.coursewareIdSub(id).then(() => {
        this.$message.success("订阅成功");
        this.coursewareInfo.is_subscribed = true;
      });
    },
    getData() {
      this.loading = true;
      let id = this.$route.params.id;
      classService
        .coursewareDetail(id)
        .then(res => {
          this.coursewareInfo = res;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.hanle-button {
  display: flex;
}
.worksCenterdatails-section {
  width: 70%;
  margin: 0 auto;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  color: #2c3e50;
  .datails-mark {
    border-bottom: 1px solid #e4e4e4;
    padding-bottom: 10px;
    /deep/.el-breadcrumb__item {
      font-size: 12px;
    }
  }
  .datails-title {
    font-size: 24px;
    color: #2c3e50;
    text-align: left;
    padding-top: 30px;
  }
  .datails-author {
    text-align: left;
    padding-top: 10px;
    span {
      padding-right: 20px;
    }
  }
  .datail-information {
    text-align: left;
    font-size: 12px;
    padding-top: 10px;
    .information-value {
      color: #f90;
    }
  }
  .datail-img {
    padding-top: 20px;
    img {
      width: 100%;
      object-fit: cover;
    }
  }
  .datail-button-content {
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
  }
  .worksCenterdatails-content {
    padding: 20px 0 40px 0;
    font-size: 12px;
    text-align: left;
    .worksCenterdatails-main {
      text-indent: 2em;
      span {
        color: #3f3f3f;
        font-weight: 500;
      }
      p {
        height: 25px;
        line-height: 25px;
      }
    }
    .worksCenterdatails-remarks {
      padding-top: 10px;
      span {
        padding-right: 10px;
      }
    }
  }
}
</style>
